import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PageNotFoundComponent } from "./content/pages/page-not-found/page-not-found.component";
import { loginGuard } from "./shared/utilities/login.guard";

const routes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },
  {
    path: "logout",
    redirectTo: "auth",
    pathMatch: "full",
  },
  {
    path: "auth",
    loadChildren: () =>
      import("../app/content/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "home",
    loadChildren: () =>
      import("../app/content/pages/pages.module").then((m) => m.PagesModule),
    canActivate: [loginGuard],
  },
  {
    path: "connect",
    loadChildren: () =>
      import("../app/content/pages/social-monitoring/creator-connect/creator-connect.module").then(
        (m) => m.CreatorConnectModule
      ),
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
